export default function FooterV3() {
  return <footer className='my-8' />;
}
